// =============================================================================
// Optim TURPE V2 — constantes et drapeaux NOMMÉS de la page (DEV-1913).
//
// Règle de la maison : une session ne tranche jamais une question posée à
// Mathieu. Chaque recommandation codée ici est isolée derrière une constante
// nommée, listée dans la PR, et se change en une ligne.
// =============================================================================

/**
 * Fin de VIE de la V1 : fin de l'année 2026 (A13). D30 : arrêt confirmé si 90 %
 * au moins des études lancées à l'écran passent par la V2 pendant quatre semaines.
 */
export const FIN_DE_VIE_V1 = "2026-12-31"

/**
 * Fin de l'ASSISTANCE de la V1 : la même date que la fin de vie (revue
 * d'ouverture du 12/10/2026, C10 et Q3, décidé par Mathieu le 13/10). L'ancienne
 * valeur, « ouverture + 15 jours » (27/10/2026), reposait sur une ouverture qui
 * n'est plus datée et contredisait l'aide, l'annonce et le kit. Une seule date,
 * écrite une seule fois : la page V1 et l'aide disent la même.
 */
export const FIN_SUPPORT_V1 = FIN_DE_VIE_V1

/**
 * Le bouton de téléchargement du rapport PDF V2 est MASQUÉ tant que la route
 * de rendu n'existe pas (constat F8.1) — masqué, pas grisé : un bouton grisé
 * promet une action qui n'existe pas. Le lot DEV-1914 traite le rapport et
 * bascule ce drapeau.
 *
 * Basculé à `true` le 25/09/2026 (DEV-1914) : la route
 * `POST /v5/optimturpe/v2/analyse/:id/rapport` est servie par api-metier sur
 * `main` (#1388) et sur `staging` (sa jumelle #1410). Le bouton reste retiré
 * pendant qu'une erreur ou un échec d'étude est à l'écran (F7.16), et l'aperçu
 * se retire de lui-même sur un 404 (`rapportIndisponible`).
 */
export const RAPPORT_PDF_V2_ACTIF = true

/**
 * La page lit la liste des segments couverts servie par le moteur
 * (`GET /optimturpe/perimetre`, DEV-1912) au lieu de recopier la règle
 * d'éligibilité. La route de façade api-metier qui la relaie n'existe pas
 * encore : tant que l'appel échoue, la page ne pré-annonce RIEN et ne recopie
 * aucune règle — elle dit qu'elle ne connaît pas le périmètre.
 */
export const PERIMETRE_SERVI_ACTIF = true

/**
 * Les gestes du cycle de vie (A12) : « rejouer », « rétablir », « supprimer »,
 * et la liste du cycle d'un compteur, servis par le lot DEV-2065.
 *
 * Basculé à `true` le 25/09/2026 (DEV-2150) : les routes sont servies par
 * courtage (#236) et par api-metier sur les deux tracks (`rejouer`, `retablir`,
 * `supprimer`, `analyses/cycle`), et les boutons sont écrits dans
 * `OptimTurpeV2Historique`. À `false`, l'historique relit l'ancienne liste de
 * la société et les boutons « Rejouer » et « Rétablir » sont ABSENTS.
 */
export const CYCLE_ROUTES_ACTIVES = true

/**
 * Seuil de REPLI qui sépare « économie » de « déjà optimale », en euros.
 *
 * Le seuil qui fait foi est celui que le moteur sert (`restitution.etat_seuil_eur`,
 * 50 € au lancement, A18). Cette constante n'est lue que sur une étude ANTÉRIEURE
 * aux lots du moteur, et la page dit alors que l'état est déduit du montant servi
 * et non servi par le moteur.
 */
export const SEUIL_ETAT_EUR_REPLI = 50
